/**
 * Highlights a matched phrase in the query:
 * - Bolds everything before the match
 * - Leaves the matched input plain
 * - Bolds everything after
 */
export const highlightRecentSearchMatch = (query: string, input: string): string => {
  if (!input.trim()) return query;

  const queryLower = query.toLowerCase();
  const inputLower = input.toLowerCase();
  const index = queryLower.indexOf(inputLower);

  if (index === -1) {
    return `<strong>${query}</strong>`;
  }

  const before = query.slice(0, index);
  const match = query.slice(index, index + input.length);
  const after = query.slice(index + input.length);

  return [before && `<strong>${before}</strong>`, match, after && `<strong>${after}</strong>`]
    .filter(Boolean)
    .join('');
};

/**
 * Filters recent searches by checking if the query includes the typed phrase.
 */
export const filterRecentSearchesByInput = (recentSearches: string[], input: string): string[] => {
  const normalized = input.trim().toLowerCase();
  if (!normalized) return recentSearches;

  return recentSearches.filter((query) => query.toLowerCase().includes(normalized));
};
